import { ShinseiService } from "@/service/ShinseiService";
import { ZanFurikyuuRes } from "@/types/Shinsei";
import { ref, computed } from "vue";
import { Logger } from "@/utils/Logger";
import { DialogService } from "@/service/DialogService";
import axios from "axios";

export function useFurikyuu() {
  const loading = ref(0) // APIで読み込みをする本数
  const isError = ref(false)
  const srv = new ShinseiService();

  const zanFurikyuu = ref<ZanFurikyuuRes | null>(null);

  // 振休残数の取得（zanFurikyuu.value に結果をセット）
  const getZanFurikyuuCount = async (userId: number, koyouKeiyakuId?: number) => {
    loading.value++
    try {
      zanFurikyuu.value = await srv.getZanFurikyuuCount(userId, koyouKeiyakuId);
    } catch (e) {
      isError.value = true
      if (axios.isAxiosError(e) && e.response?.status === 404) {
        // 404 の場合は続行可能である旨を通知し、re-throw しない
        await DialogService.warning({
          title: '振休残数の取得に失敗しました',
          html: '申請の提出／閲覧は続行可能です。<br>ブラウザの場合は更新を、アプリをご利用の場合は画面左上の歯車マークより「キャッシュのクリア」を実行してください。<br>※クリア後は画面が更新されますのでお手数ですが再度申請画面を開いてください。'
        }, true)
        return
      }
      throw e
    } finally {
      loading.value--
    }
  }

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value)
  })

  return {
    isLoading,
    zanFurikyuu,
    getZanFurikyuuCount
  }
}
